import { Component, Input } from '@angular/core';

@Component({
    selector: 'truncate-text',
    templateUrl: './truncate-text.component.html',
    styleUrls: ['./truncate-text.component.css'],
    standalone: false
})
export class TruncateTextComponent {
  @Input() inputText: string;
  @Input() limit: number = 20;
  @Input() block: boolean = true;
  @Input() textColor: string = 'var(--zint-grey-600)';
  @Input() showEllipsis = false;

  isExpanded: boolean = false;

  get displayText(): string {
    if (this.inputText === undefined || this.inputText === null){this.inputText = ''}

    if (this.isExpanded || !this.inputText) {
      return this.inputText;
    }

    this.inputText = this.inputText?.toString();

    const words = this.inputText.split(' ');
    if (words.length <= this.limit) {
      return this.inputText;
    }

    return (
      words.slice(0, this.limit).join(' ') + `${this.showEllipsis ? '' : '...'}`
    );
  }

  toggleText(): void {
    this.isExpanded = !this.isExpanded;
  }
}
